import { generateTestId } from "@client-shared";
import type { FormVariant } from "@shared/types";

export const setVariantFormTestId = (identifier: string): string => generateTestId("VariantForm", identifier);

/** Returns the non-empty bag sizes selected on every variant row OTHER than the given index.
 *  Used to remove a sibling row's chosen bag size from this row's dropdown so the same
 *  bag size cannot be added twice in one request. The row's own bag size is intentionally
 *  excluded from the returned list — SingleVariantForm keeps the current selection visible
 *  on top of the excluded set. */
export const getOtherRowsBagSizes = (variants: readonly FormVariant[] | undefined, index: number): readonly string[] => {
  if (!variants?.length) return [];
  return variants
    .filter((_, i) => i !== index)
    .map((variant) => variant.bagSize)
    .filter((bagSize): bagSize is string => Boolean(bagSize));
};
